// © Microsoft Corporation. All rights reserved.
import { MessageType } from "./Constants";
import { logger } from "./Logger";
import { registerSubscription } from "./PostMessage";
const commandMessageHandlers = new Map();
const dataMessageHandlers = new Map();
/**
 * Initializes message handler
 */
export function initializeMessageHandler() {
    onmessage = (event) => {
        const { data: message } = event;
        logger.info(`WebWorker.onMessage: [type ${message.type}] [id ${message.id}]`);
        if (message.type === MessageType.Data) {
            const handler = dataMessageHandlers.get(message.id) || dataMessageHandlers.get("default");
            if (handler) {
                handler(message);
                return;
            }
        }
        if (message.type === MessageType.Subscription) {
            registerSubscription(message);
            return;
        }
        if (message.type === MessageType.Command) {
            executeCommand(message);
            return;
        }
        logger.error(`WebWorker.onMessage: Cannot handle message. [type ${message.type}] [id ${message.id}]`);
    };
}
/**
 * Registers the action to be execute on receiving the message
 * @param messageId Message Id
 * @param action Action to execute
 */
export function registerCommandMessageHandler(messageId, action) {
    const handlers = commandMessageHandlers.get(messageId);
    commandMessageHandlers.set(messageId, [...(handlers || []), action]);
}
/**
 * Registers the action to be executed on receiving a message with the specific message id
 * @param messageId Message Id
 * @param handler Action to execute
 */
export function registerDataMessageHandler(messageId, handler) {
    dataMessageHandlers.set(messageId, handler);
}
/**
 * Execute actions for command type messages from main thread
 * @param message message
 */
function executeCommand(message) {
    const commandHandlers = commandMessageHandlers.get(message.id);
    if (!commandHandlers || !commandHandlers.length) {
        logger.error(`WebWorker.onMessage: Cannot handle message. [type ${message.type}] [id ${message.id}]`);
        return;
    }
    commandHandlers.forEach((callback, index) => {
        try {
            if (callback) {
                callback(message.payload);
            }
        }
        catch (ex) {
            logger.error(`Error executing command handler for message id [${message.id}] at handler index [${index}] . Error: ${ex}`);
        }
    });
}
//# sourceMappingURL=MessageHandler.js.map